import { render } from "./PricingSection.vue?vue&type=template&id=12cd7a44&scoped=true&ts=true"
import script from "./PricingSection.vue?vue&type=script&lang=ts"
export * from "./PricingSection.vue?vue&type=script&lang=ts"

import "./PricingSection.vue?vue&type=style&index=0&id=12cd7a44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12cd7a44"]])

export default __exports__